// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__pEQyX","label":"LabeledBox_label__2dXxW"};